<template>
    <app-layout>
     <Head title="Forms"/>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Forms
                </h2>
                <Link
                    v-if="
                        webforms.data.length > 0 ||
                            form.search != null ||
                            resetting
                    "
                    :href="route('web-forms.create')"
                    class="inline-flex items-center px-4 py-2 bg-orange-400 border border-transparent rounded-md font-bold text-xs text-white uppercase tracking-widest hover:bg-orange-500 active:bg-orange-600 focus:outline-none focus:border-orange-600 focus:ring-orange transition ease-in-out duration-150"
                    >Create Form</Link
                >
            </div>
        </template>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8">
                    <div
                        v-if="
                            webforms.data.length > 0 ||
                                form.search != null ||
                                resetting
                        "
                    >
                        <div class="flex items-center justify-between mb-6">
                            <search-filter
                                v-model="form.search"
                                class="mr-4 w-full max-w-md"
                                :modelValue.sync="form.search"
                                @reset="reset"
                            />
                        </div>
                        <div class="w-full">
                            <table class="whitespace-nowrap min-w-md w-full">
                                <thead>
                                    <tr class="text-left font-bold">
                                        <th class="pb-4 pt-6 px-6">Name</th>
                                        <th class="pb-4 pt-6 px-6">List</th>
                                        <th class="pb-4 pt-6 px-6">Signups</th>
                                        <th class="pb-4 pt-6 px-6">Code</th>
                                        <th class="pb-4 pt-6 px-6" colspan="2">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="webform in webforms.data"
                                        :key="webform.id"
                                        class="focus-within:bg-gray-100"
                                    >
                                        <td class="border-t px-6 py-4">
                                            {{ webform.name }}
                                        </td>
                                        <td class="border-t px-6 py-4">
                                            <ul>
                                                <li
                                                    v-for="(group,
                                                    key,
                                                    index) in webform.groups"
                                                    :key="key"
                                                >
                                                    {{ group.title
                                                    }}<span
                                                        v-if="
                                                            index + 1 <
                                                                webform.groups
                                                                    .length
                                                        "
                                                        >,
                                                    </span>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="border-t px-6 py-4">
                                            {{ webform.signup_count }}
                                        </td>
                                        <td class="border-t px-6 py-4">
                                            <button
                                                @click="
                                                    toggleCodeModal(webform.uuid)
                                                "
                                                class="text-blue-500 hover:text-blue-600 focus:outline-none"
                                            >
                                                Get code
                                            </button>
                                        </td>
                                        <td class="w-px border-t px-6 py-4">
                                            <jet-dropdown
                                                class="flex justify-center"
                                            >
                                                <template #trigger>
                                                    <button
                                                        class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-gray-100 hover:bg-gray-200 focus:outline-none"
                                                    >
                                                        <svg
                                                            class="h-5 w-5 text-gray-600"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                            aria-hidden="true"
                                                        >
                                                            <path
                                                                d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                                                            />
                                                        </svg>
                                                    </button>
                                                </template>

                                                <template #content>
                                                    <Link
                                                        :href="
                                                            route(
                                                                'web-forms.edit',
                                                                [webform.uuid]
                                                            )
                                                        "
                                                        class="flex items-center w-full px-4 py-2 text-sm leading-5 text-left text-gray-600 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                    >
                                                        <svg
                                                            class="mr-3 h-5 w-5 group-hover:text-gray-500"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                            aria-hidden="true"
                                                        >
                                                            <path
                                                                d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                                                            />
                                                            <path
                                                                fill-rule="evenodd"
                                                                d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                                                clip-rule="evenodd"
                                                            />
                                                        </svg>
                                                        Edit
                                                    </Link>
                                                    <Link
                                                        :href="
                                                            route(
                                                                'web-forms.preview',
                                                                [webform.uuid]
                                                            )
                                                        "
                                                        class="flex items-center w-full px-4 py-2 text-sm leading-5 text-left text-gray-600 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            class="mr-3 h-5 w-5 group-hover:text-gray-500"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                d="M10 12a2 2 0 100-4 2 2 0 000 4z"
                                                            />
                                                            <path
                                                                fill-rule="evenodd"
                                                                d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                                                clip-rule="evenodd"
                                                            />
                                                        </svg>
                                                        Preview
                                                    </Link>
                                                    <div
                                                        class="border-t border-gray-100"
                                                    ></div>
                                                    <button
                                                        @click="
                                                            confirmDelete(webform.uuid)
                                                        "
                                                        class="flex items-center w-full px-4 py-2 text-sm leading-5 text-left text-gray-600 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            class="mr-3 h-5 w-5 group-hover:text-gray-500"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                fill-rule="evenodd"
                                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                                clip-rule="evenodd"
                                                            />
                                                        </svg>
                                                        Delete
                                                    </button>
                                                </template>
                                            </jet-dropdown>
                                        </td>
                                    </tr>
                                    <tr v-if="webforms.data.length === 0">
                                        <td class="px-6 py-4 border-t" colspan="4">
                                            No webforms found.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <pagination class="mt-6" :links="webforms.links" />
                    </div>
                    <div v-else class="text-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="mx-auto h-12 w-12 text-gray-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                vector-effect="non-scaling-stroke"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                            />
                        </svg>
                        <h3 class="mt-2 text-sm text-gray-900">
                            No Sign-Up Forms
                        </h3>
                        <p class="mt-1 text-sm text-gray-500">
                            Create a form and place it on your website for contacts to subscribe to your lists.
                        </p>
                        <div class="mt-6">
                            <Link
                                :href="route('web-forms.create')"
                                class="inline-flex items-center px-4 py-2 bg-orange-400 border border-transparent rounded-md font-bold text-xs text-white uppercase tracking-widest hover:bg-orange-500 active:bg-orange-600 focus:outline-none focus:border-orange-600 focus:ring-orange transition ease-in-out duration-150"
                            >
                                New Form
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <jet-dialog-modal
            :show="showCodeModal"
            @close="showCodeModal = false"
            ref="modal"
        >
            <template #title>Get code</template>

            <template #content>
                <div class="flex flex-wrap">
                    <div class="w-full">
                        <ul
                            class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                        >
                            <li class="-mb-px mr-6 last:mr-0 text-center">
                                <a
                                    class="text-xs font-bold uppercase py-3 block leading-normal bg-white cursor-pointer"
                                    v-on:click="toggleTabs(1)"
                                    v-bind:class="{
                                        'text-gray-900 hover:text-gray-600':
                                            openTab !== 1,
                                        'text-blue-500': openTab === 1
                                    }"
                                >
                                    Link
                                </a>
                            </li>
                            <li class="-mb-px mr-6 last:mr-0 text-center">
                                <a
                                    class="text-xs font-bold uppercase py-3 block leading-normal bg-white cursor-pointer"
                                    v-on:click="toggleTabs(2)"
                                    v-bind:class="{
                                        'text-gray-900 hover:text-gray-600':
                                            openTab !== 2,
                                        'text-blue-500': openTab === 2
                                    }"
                                >
                                    iframe
                                </a>
                            </li>
                        </ul>
                        <p class="mb-5">Copy and paste the code below.</p>
                        <div
                            class="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 rounded"
                        >
                            <div class="px-4 py-5 flex-auto">
                                <div class="tab-content tab-space">
                                    <div
                                        v-bind:class="{
                                            hidden: openTab !== 1,
                                            block: openTab === 1
                                        }"
                                    >
                                        <code
                                            class="text-gray-700 text-sm"
                                            v-text="getCodeAnchor"
                                        ></code>
                                    </div>
                                    <div
                                        v-bind:class="{
                                            hidden: openTab !== 2,
                                            block: openTab === 2
                                        }"
                                    >
                                        <code
                                            class="text-gray-700 text-sm"
                                            v-text="getIframeAnchor"
                                        ></code>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <button class="mr-2" @click="toggleCodeModal(null)">
                    Close
                </button>
            </template>
        </jet-dialog-modal>

        <jet-dialog-modal
            :show="showDeleteModal"
            @close="showDeleteModal = false"
        >
            <template #title>Confirm Deletion</template>

            <template #content>
                Are you sure you want to delete this form? This action cannot be undone.
            </template>

            <template #footer>
                <jet-secondary-button @click="showDeleteModal = false">
                    Cancel
                </jet-secondary-button>

                <jet-danger-button @click="confirmDelete()" class="ml-4">
                    Delete
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetDropdown from "../../Jetstream/Dropdown";
import JetDialogModal from "../../Jetstream/DialogModal";

import SearchFilter from "../../components/SearchFilter";
import Pagination from "../../components/Pagination";
import { debounce, mapValues, pickBy } from "lodash";

export default {
    mounted() {},
    components: {
        AppLayout,
        JetDropdown,
        JetDialogModal,
        SearchFilter,
        Pagination
    },
    props: {
        filters: Object | Array,
        webforms: Object
    },
    data() {
        return {
            form: {
                search: this.filters.search
            },
            openTab: 1,
            resetting: false,
            getCodeUuid: null,
            showCodeModal: false,
            showDeleteModal: false,
            deleteId: null,
        };
    },
    computed: {
        getCodeAnchor() {
            return `
                <a href="${window.location.origin}/join/web-forms/${this.getCodeUuid}" target="_blank">Subscribe now</a>
            `;
        },
        getIframeAnchor() {
            return `
                <iframe src="${window.location.origin}/join/web-forms/${this.getCodeUuid}" width="100%" height="576" scrolling="no"></iframe>
            `;
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function() {
                this.$inertia.get("/web-forms", pickBy(this.form), {
                    preserveState: true,
                    replace: true,
                    onFinish: () => {
                        this.resetting = false;
                    }
                });
            }, 250)
        }
    },
    methods: {
        reset() {
            this.resetting = true;
            this.form = mapValues(this.form, () => null);
        },
        confirmDelete(id) {
            console.log("confirmDelete", id);
            if (id) {
                this.deleteId = id;
                this.showDeleteModal = true;
            } else if (this.deleteId) {
                this.$inertia.delete(`/web-forms/${this.deleteId}`, {
                    onSuccess: page => {
                        this.showDeleteModal = false;
                        this.deleteId = null;
                    },
                    onError: error => {
                        console.log(error);
                    }
                });
            }
        },
        toggleTabs: function(tabNumber) {
            this.openTab = tabNumber;
        },
        toggleCodeModal(id) {
            this.getCodeUuid = id;
            this.showCodeModal = !this.showCodeModal;
        }
    }
};
</script>
